import { render } from "./PageNotFoundView.vue?vue&type=template&id=741cb3dd&scoped=true"
const script = {}

import "./PageNotFoundView.vue?vue&type=style&index=0&id=741cb3dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741cb3dd"]])

export default __exports__